import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "nge-mt-card",
  role: "dialog",
  "aria-label": "Mobile tour"
}
const _hoisted_2 = { class: "nge-mt-head" }
const _hoisted_3 = { class: "nge-mt-count" }
const _hoisted_4 = { class: "nge-mt-title" }
const _hoisted_5 = { class: "nge-mt-body" }
const _hoisted_6 = { class: "nge-mt-foot" }
const _hoisted_7 = { class: "nge-mt-dots" }
const _hoisted_8 = { class: "nge-mt-actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "nge-mt" }, {
      default: _withCtx(() => [
        ($props.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString($setup.i + 1) + " / " + _toDisplayString($setup.STEPS.length), 1 /* TEXT */),
                _createElementVNode("button", {
                  class: "nge-mt-skip",
                  onClick: $setup.finish
                }, "Skip")
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString($setup.step.title), 1 /* TEXT */),
              _createElementVNode("p", _hoisted_5, _toDisplayString($setup.step.body), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.STEPS, (s, n) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: n,
                      class: _normalizeClass(["nge-mt-dot", { 'nge-mt-dot--on': n === $setup.i }])
                    }, null, 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_8, [
                  ($setup.i > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-mt-back",
                        onClick: $setup.back
                      }, "Back"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    class: "nge-mt-next",
                    onClick: $setup.next
                  }, _toDisplayString($setup.i === $setup.STEPS.length - 1 ? 'Start exploring' : 'Next'), 1 /* TEXT */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}